import { CircularProgress } from '@material/mwc-circular-progress';

export class SmpvLoader extends CircularProgress {}

customElements.define('smpv-loader', SmpvLoader);
